import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import {
	FieldConfiguration,
	GroupFieldConfiguration,
	LookupFieldConfiguration,
} from '../../../api/ConfigApi';
import {
	FieldGroupCreateRequest,
	FieldGroupsByLocatorMap,
	FieldValuesMap,
} from '../../../types/policy';
import FieldLabel from '../../fields/FieldLabel';
// import { FieldValuesMap } from '../../../types/policy';
import GroupFieldReviewChanges from '../fields/GroupFieldReviewChanges';
import LookupField from '../fields/LookupField';

interface Props {
	field: FieldConfiguration;
	value?: any;
	fieldGroupsByLocator?: FieldGroupsByLocatorMap;
	allValues: FieldValuesMap;
	currentFieldValues?: FieldValuesMap;
	addFieldGroups?: FieldGroupCreateRequest[];
}

const useStyles = makeStyles((theme) => ({
	disabledInput: {
		'& .MuiInputBase-root.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	},
}));

// Field component for review changes page
const ReviewChangesField = (props: Props) => {
	const classes = useStyles();
	const { field, value, addFieldGroups, currentFieldValues } = props;

	const style = { marginRight: '10px', marginBottom: '10px' };

	switch (field.type) {
		case 'group':
			return (
				<GroupFieldReviewChanges
					field={field as GroupFieldConfiguration}
					fieldGroupLocators={value}
					fieldGroupsByLocator={props.fieldGroupsByLocator}
					// mediaHandler={props.mediaHandler}
					addFieldGroups={addFieldGroups}
					currentFieldValues={currentFieldValues}
				/>
			);
		case 'lookup':
			return (
				<LookupField
					field={field as LookupFieldConfiguration}
					value={value}
					allValues={props.allValues}
					style={style}
					readOnly
				/>
			);
		default:
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<TextField className={classes.disabledInput} value={value} disabled />
				</FormControl>
			);
	}
};

export default ReviewChangesField;
